import * as Facebook from 'fb-sdk-wrapper';

Facebook.load()
  .then(() => {
    Facebook.init({
      appId: 390833657663844
    });
  });

